"use client";

import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "stores/hooks";
import { selectSearchQuery } from "stores/search/searchSlice";
import { markUI } from "stores/ui/uiSlice";
export const ClosePropertyCardWhenSearchParamsChanged = () => {
  const dispatch = useAppDispatch();
  const searchQuery = useAppSelector(selectSearchQuery);
  useEffect(() => {
    dispatch(markUI({
      openedPropertyCardInMapBox: null
    }));
    // whenever searchQuery changes then just close the opend card
  }, [dispatch, searchQuery]);
  return null;
};